import { prepareIconsLinksToSave } from "../helpers/file.helper";
import { WhitelabelIosConfig } from "../models/whitelabel-ios-config";

export default class WhitelabelIosConfigFactory {
    
    private whitelabelIosConfig: WhitelabelIosConfig = new WhitelabelIosConfig();

    public constructor(){}

    public withName(name: string) {
        this.whitelabelIosConfig.name = name;
        return this;
    }

    public withStatus(status: number) {
        this.whitelabelIosConfig.status = status;
        return this;
    }

    public withAppId(appId: string | null) {
        this.whitelabelIosConfig.appId = appId;
        return this;
    }

    public withAssociatedDomain(host: string) {
        this.whitelabelIosConfig.associatedDomain = host;
        return this;
    }
    
    public withIntentScheme(intentScheme: string) {
        this.whitelabelIosConfig.intentScheme = intentScheme;
        return this;
    }

    public withDevelopmentTeam(developmentTeam: string | null) {
        this.whitelabelIosConfig.developmentTeam = developmentTeam;
        return this;
    }

    public withIosBundleId(iosBundleId: string | null) {
        this.whitelabelIosConfig.iosBundleId = iosBundleId;
        return this;
    }

    public withApplicationGroup(applicationGroup: string | null){
        this.whitelabelIosConfig.applicationGroup = applicationGroup;
        return this;
    }

    public withApiKeyId(apiKeyId: string | null){
        this.whitelabelIosConfig.apiKeyId = apiKeyId;
        return this;
    }

    public withApiKeyIssuerId(apiKeyIssuerId: string | null){
        this.whitelabelIosConfig.apiKeyIssuerId = apiKeyIssuerId;
        return this;
    }

    public withApiTokenBase64(apiTokenBase64: string | null){
        this.whitelabelIosConfig.apiTokenBase64 = apiTokenBase64;
        return this;
    }
    
    public withOneSignalBundleId(oneSignalBundleId: string | null){
        this.whitelabelIosConfig.oneSignalBundleId = oneSignalBundleId;
        return this;
    }

    public withAppProvisionProfielSpecifier(provisionProfileSpecifier: string) {
        this.whitelabelIosConfig.appProvisionProfileSpecifier = provisionProfileSpecifier;
        return this;
    }

    public withOnesignalProvisionProfielSpecifier(provisionProfileSpecifier: string | null) {
        this.whitelabelIosConfig.oneSignalProvisionProfileSpecifier = provisionProfileSpecifier;
        return this;
    }

    public withGoogleServicePlist(fileLink: string | null) {
        this.whitelabelIosConfig.googleServicePlistLink = fileLink;
        return this;
    }

    public withAppProvisionProfile(fileLink: string | null) {
        this.whitelabelIosConfig.appProvisionProfileLink = fileLink
        return this;
    }

    public withOneSignalProvisionProfile(fileLink: string | null) {
        this.whitelabelIosConfig.oneSignalProvisionProfileLink = fileLink
        return this;
    }

    public withP12Certificate(fileLink: string | null) {
        this.whitelabelIosConfig.certificateLink = fileLink
        return this;
    }

    public withIcons(filesLink: string | null) {
        if (!filesLink) return this;

        const icons = prepareIconsLinksToSave(filesLink);
        this.whitelabelIosConfig.iconsLink = icons;

        return this;
    }

    public withAppIcon(fileLink: string | null) {
        this.whitelabelIosConfig.appIconLink = fileLink
        return this;
    }

    public build() {
        return this.whitelabelIosConfig;
    }

    public withDataExpiritionCertificate(certificateExpiritionDate: string | null) {
        this.whitelabelIosConfig.iosCertificateExpiryDate = certificateExpiritionDate
        return this;
    }
}